import React from 'react';
import PropTypes from 'prop-types';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  root: {
    background: 'transparent',
    boxShadow: 'none',
    '&.MuiToggleButtonGroup-root': {
      display: 'block',
    },
    '& .MuiToggleButtonGroup-grouped': {
      padding: '0 2px',
      height: '24px',
      minWidth: '32px',
      color: '#8797c5',
      fontWeight: 'bold',
      border: 0,
      '&.Mui-selected': {
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        color: '#8797c5',
      },
    },
  },
});

const FilterToggle = (props) => {
  const classes = useStyles();
  const handleChange = (event, newValue) => {
    props.handleChange(newValue === null ? [] : newValue);
  };

  return (
    <ToggleButtonGroup
      className={classes.root}
      value={props.groupState}
      onChange={handleChange}
    >
      {props.values.map((value) => {
        const key = (typeof value === 'string') ? value : value.key;
        return (
          <ToggleButton
            key={key}
            value={key}
          >
            {(typeof value === 'string') ? value : value.display}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};

FilterToggle.defaultProps = {
  groupState: null,
};

FilterToggle.propTypes = {
  groupState: PropTypes.arrayOf(PropTypes.string),
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      display: PropTypes.string,
    })),
  ]).isRequired,
};

export default FilterToggle;
